import React, { useEffect, useState } from "react";
import { announceMedals } from "../medalEvents";

// La porte des Backrooms : sticky en bas à droite entre minuit et 1 h du
// matin, heure locale. Cliquer dessus donne la médaille, le thème, son style
// de pseudo, son avatar et sa bannière — les quatre objets retirés de la
// boutique (voir backend/index.js, SHOP_ITEMS `hidden`).
//
// Elle n'apparaît qu'aux comptes qui ne l'ont pas encore trouvée, et c'est le
// serveur qui le dit (GET /auth/me/secrets) : un marqueur dans le navigateur
// survivait à une réinitialisation des médailles, et la porte ne revenait plus.
//
// Monté une fois à la racine (voir index.js), comme le bandeau des médailles
// et la visite du gnome : elle lit le compte dans localStorage plutôt que par
// prop, pour ne pas dépendre de la branche d'écran que App.js rend alors.
const CHECK_EVERY_MS = 30000;

const API = process.env.REACT_APP_API_URL || "";

function currentToken() {
  try { return JSON.parse(localStorage.getItem("popuquiz_account"))?.token || null; }
  catch (_) { return null; }
}

export default function BackroomsDoor() {
  const [visible, setVisible] = useState(false);
  const [opening, setOpening] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      const token = currentToken();
      // Hors de la fenêtre, pas de question au serveur.
      if (new Date().getHours() !== 0 || !token) { setVisible(false); return; }
      try {
        const r = await fetch(`${API}/auth/me/secrets`, { headers: { Authorization: `Bearer ${token}` } });
        const d = r.ok ? await r.json() : null;
        if (!cancelled) setVisible(!!d && !d.backrooms);
      } catch (_) {
        if (!cancelled) setVisible(false);
      }
    };
    check();
    const id = setInterval(check, CHECK_EVERY_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  const open = () => {
    const token = currentToken();
    if (!token || opening) return;
    setOpening(true);
    fetch(`${API}/auth/me/secret`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ id: "backrooms" }),
    }).then(r => r.json()).then(d => announceMedals(d.medals)).catch(() => {});
    // laisse jouer l'animation d'ouverture
    setTimeout(() => { setVisible(false); setOpening(false); }, 500);
  };

  if (!visible) return null;
  return (
    <button type="button" className={`backrooms-door${opening ? " opening" : ""}`}
      onClick={open} aria-label="???">
      <img src="/sprite/backrooms-door.webp" alt="" />
    </button>
  );
}
